<section class="secondary-drawer-container">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
    <h5 class="drawer-title">PDF Viewer</h5>
</section>
<div class="custom-scroller">
    <pdf-viewer *ngIf="url" [src]="url" class="invoice-pdf-viewer" [original-size]="false">
    </pdf-viewer>
</div>
<div class="inner-drawer-actions">
    <button type="button" (click)="downloadPDF()" class="common-button black mat-elevation-z0 ms-2 text-transform-unset"
        mat-button mat-raised-button>Download PDF</button>
</div>